import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToolsModule } from 'projects/tools/src/lib/tools.module';
import { OrdersListComponent } from './orders-list/orders-list.component';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { HttpClientModule ,HTTP_INTERCEPTORS} from '@angular/common/http';
import { AddTestModalComponent } from './modal-popups/add-test-modal/add-test-modal.component';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { DeleteItemModalComponent } from './modal-popups/delete-item-modal/delete-item-modal.component';
import { ItemsReassignModalComponent } from './modal-popups/items-reassign-modal/items-reassign-modal.component';
import { CommonModule, DatePipe } from '@angular/common';
import { ReScheduleItemComponent } from './modal-popups/re-schedule-item/re-schedule-item.component';
//import { UploadReportComponent } from './modal-popups/upload-report/upload-report.component';
import { ReportDetailsComponent } from './modal-popups/report-details/report-details.component';
import { OrderCancelModelComponent } from './modal-popups/order-cancel-model/order-cancel-model.component';
import { DiagnosticCenterAddressComponent } from './orders-list/diagnostic-center-address/diagnostic-center-address.component';
import { ReportUploadLinkComponent } from './orders-list/report-upload-link/report-upload-link.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UploadReportDataComponent } from './modal-popups/upload-report-data/upload-report-data.component';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { VerityOtpComponent } from './modal-popups/verity-otp/verity-otp.component';
import { PrescriptionUploadComponent } from './modal-popups/prescription-upload/prescription-upload.component';
import { LogoutConfirmModalComponent } from './modal-popups/logout-confirm-modal/logout-confirm-modal.component';
import { OrderRejectModalComponent } from './modal-popups/order-reject-modal/order-reject-modal.component';
import { TrackOrderComponent } from './modal-popups/track-order/track-order.component'; 
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AutoFocusDirective } from './auto-focus.directive';
import { AvailableLabTimingsComponent } from './order-details/available-lab-timings/available-lab-timings.component';

import { AppHttpInterceptor } from './AppHttpInterceptor';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ToastrModule } from 'ngx-toastr';
import { ConfirmModalComponent } from './modal-popups/confirm-modal/confirm-modal.component';
import { EconsultReassignModalComponent } from './modal-popups/econsult-reassign-modal/econsult-reassign-modal.component';
import { LoginComponent } from './login/login.component';
import { GeneratePaymentLinkComponent } from './modal-popups/generate-payment-link/generate-payment-link.component';
import { ReimbursementListComponent } from './reimbursement-list/reimbursement-list.component';
import { ReimbursementDetailsComponent } from './reimbursement-details/reimbursement-details.component';
import { ReimburseModalComponent } from './modal-popups/reimburse-modal/reimburse-modal.component';
import { TrackReimbursementComponent } from './modal-popups/track-reimbursement/track-reimbursement.component';
import { EscalationsComponent } from './escalations/escalations.component';
import { EscalationDetailsComponent } from './escalation-details/escalation-details.component';
import { ReAllocationComponent } from './modal-popups/re-allocation/re-allocation.component';
import { RefundPageComponent } from './refund-page/refund-page.component';
import { SamplesCollectedComponent } from './modal-popups/samples-collected/samples-collected.component';
import { SamplesSubmitedComponent } from './modal-popups/samples-submited/samples-submited.component';
import { PrintDocumentsComponent } from './modal-popups/print-documents/print-documents.component';
import { UcdUsersComponent } from './ucd-users/ucd-users.component';
import { AddUsersComponent } from './ucd-users/add-users/add-users.component';
import { LeadsComponent } from './leads/leads.component';
import { LocationPickerComponent } from './location-picker/location-picker.component';
import { AgmCoreModule } from '@agm/core';
import { GeocodeService } from './services/geocode.service';
import { ChildOrdersListComponent } from './child-orders-list/child-orders-list.component';
import { PreAssessmentFormComponent } from './pre-assessment-form/pre-assessment-form.component';


@NgModule({
  declarations: [
    AppComponent,
    OrdersListComponent,
    OrderDetailsComponent,
    AddTestModalComponent,
    DeleteItemModalComponent,
    ItemsReassignModalComponent,
    ReScheduleItemComponent,
    //UploadReportComponent,
    ReportDetailsComponent,
    OrderCancelModelComponent,
    DiagnosticCenterAddressComponent,
    ReportUploadLinkComponent,
    UploadReportDataComponent,
    PagenotfoundComponent,
    VerityOtpComponent,
    PrescriptionUploadComponent,
    LogoutConfirmModalComponent,
    OrderRejectModalComponent,
    TrackOrderComponent,
    AutoFocusDirective,
    AvailableLabTimingsComponent,
    ConfirmModalComponent,
    EconsultReassignModalComponent,
    LoginComponent,
    GeneratePaymentLinkComponent,
    ReimbursementListComponent,
    ReimbursementDetailsComponent,
    ReimburseModalComponent,
    TrackReimbursementComponent,
    EscalationsComponent,
    EscalationDetailsComponent,
    ReAllocationComponent,
    RefundPageComponent,
    SamplesCollectedComponent,
    SamplesSubmitedComponent,
    PrintDocumentsComponent,
    UcdUsersComponent,
    AddUsersComponent,
    LeadsComponent,
    LocationPickerComponent,
    ChildOrdersListComponent,
    PreAssessmentFormComponent,
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    NgSelectModule,
    NgbTimepickerModule,
    ToolsModule,
    HttpClientModule,
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    NgxSpinnerModule,
    BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDdBOhh1q07dhphxKkOOiOwzPAFWSLqXks', libraries: ["places"]
  }),

    ToastrModule.forRoot({
      timeOut: 2000,
      positionClass: 'toast-top-right',
      preventDuplicates: true
      // progressAnimation: 'increasing',
      // progressBar: true
    })
  ],
  providers: [NgbActiveModal,GeocodeService,
    {
        provide: HTTP_INTERCEPTORS,
        useClass: AppHttpInterceptor,
        multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
